






































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListWorkShifts } from '@/components/config'

// services
import { WorkShiftService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { WorkShiftForm, WorkShiftModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditWorkShift from './modalCreateEdit.vue'

const newItem: WorkShiftForm = {
  name: '',
  checkin_time: '',
  checkout_time: '',
  lunch_time_entry: '',
  lunch_time_ends: '',
  week_days: [],
  is_active: true,
  is_cumulative: false,
  is_nocturnal: false
}

@Component({
  name: 'WorkShiftsIndex',
  components: {
    PageHeader,
    TableListWorkShifts,
    ModalCreateEditWorkShift
  }
})
export default class WorkShiftsIndex extends Vue {
  showModal = false
  workShift: WorkShiftForm = newItem
  title = 'Turnos de Trabajo'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Turnos de Trabajo',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.workShift = newItem
    this.showModal = true
  }

  editItem (item: WorkShiftModel) {
    this.workShift = {
      name: item.name,
      checkin_time: item.checkin_time,
      checkout_time: item.checkout_time,
      lunch_time_entry: item.lunch_time_entry,
      lunch_time_ends: item.lunch_time_ends,
      week_days: item.week_days_list || [],
      is_active: item.is_active,
      is_cumulative: item.is_cumulative,
      is_nocturnal: item.is_nocturnal
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: WorkShiftModel) {
    const msg = `Seguro que desea eliminar el Turno de Trabajo: ${item.name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await WorkShiftService.delete(item.id)
      alerts.success()
      this.tableList.getWorkShiftsWithPagination()
      loading('hide')
    }
  }

  async changeStatus (info: {id: number; status: boolean}) {
    loading('show')
    try {
      await WorkShiftService.changeStatus(info.id, info.status)
      alerts.success()
      this.tableList.getWorkShiftsWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getWorkShiftsWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getWorkShiftsWithPagination: () => void }
  }

  get itemInit (): WorkShiftForm {
    return newItem
  }
}
